import { css } from '@emotion/css';

export const blurBackground = css`
  backdrop-filter: blur(10px);
`;

export const borderRadius8 = css`
  border-radius: 0.8rem;
`;

export const smallMediumIconStyles = css`
  svg {
    width: 2rem;
    height: 2rem;
    flex-shrink: 0;
  }
`;

export const resetIconMargin = css`
  .MuiButton-startIcon {
    margin-inline-start: 0;
  }
  .MuiButton-endIcon {
    margin-inline-end: 0;
  }
`;

export const largeIconStyles = css`
  svg {
    width: 2.4rem;
    height: 2.4rem;
    flex-shrink: 0;
  }
`;

export const focusStylesInteractive01 = css`
  &.Ly-focusVisible,
  &.Mui-focusVisible {
    outline: 0.16rem solid transparent;
    box-shadow: 0 0 0 0.16rem var(--interactive-white), 0 0 0 0.32rem var(--interactive-primary);
  }
`;

export const focusStylesInteractive03 = css`
  &.Ly-focusVisible,
  &.Mui-focusVisible {
    outline: 0.16rem solid transparent;
    box-shadow: 0 0 0 0.16rem var(--interactive-primary), 0 0 0 0.32rem var(--interactive-white);
  }
`;

export const ghostFocusStylesInteractive01 = css`
  &.Ly-focusVisible,
  &.Mui-focusVisible {
    outline: 0.16rem solid transparent;
    box-shadow: 0 0 0 0.16rem var(--interactive-primary);
  }
`;

export const primaryFocusStyles = css`
  &.Ly-focusVisible {
    outline: 0.1rem solid transparent;
    box-shadow: 0px 0px 0px 0.3rem var(--blue-300);
  }
`;

export const shadowFocusStyles = css`
  &.Ly-focusVisible {
    outline: 0.1rem solid transparent;
    box-shadow: var(--shadow-01), 0px 0px 0px 0.3rem var(--blue-300);
  }
`;

export const ghostFocusStylesInteractive03 = css`
  &.Ly-focusVisible,
  &.Mui-focusVisible {
    outline: 0.16rem solid transparent;
    box-shadow: 0 0 0 0.16rem var(--interactive-white);
  }
`;

export const alignmentExtreme = css`
  .MuiButton-startIcon {
    position: absolute;
    left: 2rem;
  }

  .MuiButton-endIcon {
    position: absolute;
    right: 2rem;
  }
`;

export const paddingY15 = css`
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
`;

export const height56 = css`
  height: 5.6rem;
`;

export const width56 = css`
  width: 5.6rem;
`;

export const minWidth180 = css`
  min-width: 18rem;
`;

export const minWidth150 = css`
  min-width: 15rem;
`;

export const minWidth120 = css`
  min-width: 12rem;
`;

export const minWidth90 = css`
  min-width: 9rem;
`;

export const minWidth72 = css`
  min-width: 7.2rem;
`;
